import { render, staticRenderFns } from "./InvestorArticleResult.vue?vue&type=template&id=41ed6b8c"
import script from "./InvestorArticleResult.vue?vue&type=script&lang=js"
export * from "./InvestorArticleResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports